<template>
    <div class="setting-wrapper">
        <div class="setting">
            <h4 class="lg:w-1/5">
                {{ lang('Nummerhantering','Number settings') }}
            </h4>
            <div v-if="toggled" class="text-sm text-neutral-dark mb-lg md:mb-xl lg:hidden">
                {{ description }}
            </div>
            <div class="w-full flex items-center w-full lg:w-4/5">
                <div class="w-full mr-auto text-sm text-neutral-darker lg:w-5/6">
                    <div class="w-full flex flex-col md:flex-row">
                        <div class="w-full md:w-1/5 md:mr-sm">
                            <text-input
                                v-model="areaCode"
                                name="area_code"
                                inputmode="numeric"
                                :label="lang('Riktnummer','Area code')"
                                :required="true"
                            />
                        </div>
                        <div class="w-full md:w-2/5 md:mr-sm">
                            <text-input
                                v-model="phoneNumber"
                                name="phone_number"
                                inputmode="numeric"
                                :label="lang('Telefonnummer','Phone number')"
                                :required="true"
                            />
                        </div>
                        <div class="w-full md:w-2/5 md:mr-sm">
                            <order-date-picker
                                v-model="startDate"
                                name="start_date"
                                :min="deliveryMinDate"
                                :max="deliveryMaxDate"
                                :label="lang('Startdatum', 'Start date')"
                                :required="true"
                            />
                        </div>
                    </div>
                </div>
                <a
                    class="absolute pin-t pin-r flex items-center mt-xl lg:relative lg:mt-0 text-neutral-darker read-more"
                    :class="{ 'is-active' : toggled }"
                    @click="toggle"
                >
                    <font-awesome-icon icon="chevron-down" class="chevron text-sm lg:text-lg" />
                </a>
            </div>
        </div>
        <div v-if="toggled" class="text-sm text-neutral-dark mb-lg md:mb-xl hidden lg:block">
            {{ description }}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            description: {
                required: true,
                type: String,
            },
            deliveryMinDate: {
                required: true,
                type: String,
            },
            deliveryMaxDate: {
                required: true,
                type: String,
            },
        },
        data() {
            return {
                toggled: false,
                areaCode: '',
                phoneNumber: '',
                startDate: '',
            };
        },
        watch: {
            areaCode() {
                this.update();
            },
            phoneNumber() {
                this.update();
            },
            startDate() {
                this.update();
            },
        },
        methods: {
            update() {
                this.$emit('change', this.areaCode, this.phoneNumber, this.startDate);
            },
            toggle() {
                this.toggled = ! this.toggled;
            },
        },
    };
</script>